import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Button} from 'antd'
import {withTranslation} from 'react-i18next'

const {TextArea} = Input

@inject('mappingManagementStore')
@observer
class FormModal extends Component {
  formRef = React.createRef()
  handleOk = () => {
    const {mappingManagementStore, record, title} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      mappingManagementStore.onSaveVersionAction(record.id, title, {description: fieldsValue.description}).then(res => this.props.handleCancel())
    }).catch(err => {})
  }

  render() {
    const {addModalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={t(`mappingManagement.recordVersion`)}
          closable={true}
          onCancel={handleCancel}
          visible={addModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" initialValues={{description: ''}} layout="vertical">
            <Row justify="start" gutter={[10, 0]}>
              <Col span={24}>
                <Form.Item name="description" label={t(`mappingManagement.description`)}
                           rules={[{
                             message: `${t(`general.pleaseEnter`)} ${t(`mappingManagement.description`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/),
                             required: true
                           }]}>
                  <TextArea rows={6} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
